const PATH_LABELS = [
  ['/benutzer', 'Der Bereich Benutzer'],
  ['/taetigkeiten', 'Der Bereich Arten von Taetigkeiten'],
  ['/statistik', 'Der Bereich Statistik'],
  ['/eignungsverfahren', 'Der Bereich Eignungsverfahren'],
  ['/lehrgang-srht', 'Der Bereich Lehrgang SRHT'],
  ['/einsatz', 'Der Bereich Einsatz'],
  ['/uebung', 'Der Bereich Uebungsplanung'],
  ['/rueckmeldung', 'Der Bereich Rueckmeldungen'],
  ['/logbuch', 'Der Bereich Logbuch'],
  ['/eintrag-vornehmen', 'Der Eintragsbereich'],
  ['/audit', 'Der Bereich Audit Log'],
];

export const ROLE_GATE_NOTICE_KEY = 'roleGateNotice';

export function getRoleGateAreaLabel(pathname = '') {
  const normalizedPath = String(pathname || '').trim();
  const matchedEntry = PATH_LABELS.find(([prefix]) => normalizedPath.startsWith(prefix));
  return matchedEntry ? matchedEntry[1] : 'Der angeforderte Bereich';
}

export function buildRoleGateNotice(pathname = '') {
  const areaLabel = getRoleGateAreaLabel(pathname);

  return {
    severity: 'warning',
    message: `${areaLabel} ist mit Ihren aktuellen Berechtigungen nicht verfuegbar. Ihre Ansichten wurden aktualisiert.`,
  };
}